import { render } from "./balticClients.vue?vue&type=template&id=432ab738"
import script from "./balticClients.vue?vue&type=script&lang=js"
export * from "./balticClients.vue?vue&type=script&lang=js"

import "./balticClients.vue?vue&type=style&index=0&id=432ab738&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__